(function () {

    var _features = (function () {
        var helperEl = document.createElement('div'),
            helperStyle = helperEl.style,
            vendor = '',
            features = {};

        // IE8 and below
        features.oldIE = document.all && !document.addEventListener;

        features.touch = 'ontouchstart' in window;

        if (window.requestAnimationFrame) {
            features.raf = window.requestAnimationFrame;
            features.caf = window.cancelAnimationFrame;
        }

        features.pointerEvent = navigator.pointerEnabled || navigator.msPointerEnabled;

        // fix false-positive detection of old Android in new IE
        // (IE11 ua string contains "Android 4.0")

        if (!features.pointerEvent) {

            var ua = navigator.userAgent;

            // Detect if device is iPhone or iPod and if it's older than iOS 8
            // http://stackoverflow.com/a/14223920
            //
            // This detection is made because of buggy top/bottom toolbars
            // that don't trigger window.resize event.
            // For more info refer to _isFixedPosition variable in core.js

            if (/iP(hone|od)/.test(navigator.platform)) {
                var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                if (v && v.length > 0) {
                    v = parseInt(v[1], 10);
                    if (v >= 1 && v < 8) {
                        features.isOldIOSPhone = true;
                    }
                }
            }

            // Detect old Android (before KitKat)
            // due to bugs related to position:fixed
            // http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript

            var match = ua.match(/Android\s([0-9\.]*)/);
            var androidversion = match ? match[1] : 0;
            androidversion = parseFloat(androidversion);
            if (androidversion >= 1) {
                if (androidversion < 4.4) {
                    features.isOldAndroid = true; // for fixed position bug & performance
                }
                features.androidVersion = androidversion; // for touchend bug
            }
            features.isMobileOpera = /opera mini|opera mobi/i.test(ua);

            // p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
        }

        var styleChecks = ['transform', 'perspective', 'animationName', 'transition'],
            vendors = ['', 'webkit', 'Moz', 'ms', 'O'],
            styleCheckItem,
            styleName;

        for (var i = 0; i < vendors.length; i++) {
            vendor = vendors[i];

            for (var a = 0; a < styleChecks.length; a++) {
                styleCheckItem = styleChecks[a];

                // uppercase first letter of property name, if vendor is present
                styleName = vendor + (vendor ?
                    styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) :
                    styleCheckItem);

                if (!features[styleCheckItem] && styleName in helperStyle) {
                    features[styleCheckItem] = styleName;
                }
            }

            if (vendor && !features.raf) {
                vendor = vendor.toLowerCase();
                features.raf = window[vendor + 'RequestAnimationFrame'];

                if (features.raf) {
                    features.caf = window[vendor + 'CancelAnimationFrame'] ||
                        window[vendor + 'CancelRequestAnimationFrame'];
                }
            }
        }

        if (!features.raf) {
            var lastTime = 0;
            features.raf = function (fn) {
                var currTime = new Date().getTime();
                var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                var id = window.setTimeout(function () {
                    fn(currTime + timeToCall);
                }, timeToCall);
                lastTime = currTime + timeToCall;
                return id;
            };
            features.caf = function (id) {
                clearTimeout(id);
            };
        }

        // Detect SVG support
        features.svg = !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;


        return features;
    })(),
        _pointerEventEnabled = _features.pointerEvent,
        _likelyTouchDevice = _pointerEventEnabled && ((navigator.maxTouchPoints > 1) || (navigator.msMaxTouchPoints > 1)),
        _transformKey = _features.transform,
        _transitionKey = _features.transition,
        _allow3dTransform = _features.perspective && !_likelyTouchDevice,
        _translatePrefix = 'translate' + (_allow3dTransform ? '3d(' : '('),
        _translateSuffix = _features.perspective ? ', 0px)' : ')';


    // console.dir(_features);
    // console.dir(document.createElement('div'));

    function _isFunction( obj ) {

        return typeof obj === "function" && typeof obj.nodeType !== "number";
    }

    function _removeClass(el, className) {
        var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
        el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
        return this;
    }
    function _addClass(el, className) {
        if (!_hasClass(el, className)) {
            el.className += (el.className ? ' ' : '') + className;
        }
        return this;
    }
    function _hasClass(el, className) {
        return el !== null && el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
    }

    var _guid = 0;
    function _proxy( fn, context ) {
        var tmp, args, proxy;

        if ( typeof context === "string" ) {
            tmp = fn[ context ];
            context = fn;
            fn = tmp;
        }

        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if ( !_isFunction( fn ) ) {
            return undefined;
        }

        // Simulated bind
        args = [].slice.call( arguments, 2 );
        proxy = function() {
            return fn.apply( context || this, args.concat( [].slice.call( arguments ) ) );
        };

        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || _guid++;

        return proxy;
    }

     function _setTranslateX(x, elStyle, time) {
        elStyle[_transformKey] = _translatePrefix + x + '%, 0px' + _translateSuffix;
        if(time){
            elStyle[_transitionKey] = _transformKey + ' ' + time + 'ms ease'
        } else {
            elStyle[_transitionKey] = '';
        }
    }
    function _removeAnimation(elStyle) {
        if(elStyle[_transitionKey]){
             elStyle[_transitionKey] = '';
        }
    }

    var Carousel = function (element, options) {
        this.element = element;
        this.index = 0;
        this.innerImage = element.querySelector('[class~="carousel-inner-image"]');
        this.innerCaption = element.querySelector('[class~="carousel-inner-caption"]');
        this.indicators = element.querySelectorAll('[class~="carousel-indicators"] > li');
        this.isAnimation = false;
        var
            i,
            nextButtons = element.querySelectorAll('[class~="carousel-control-next"]'),
            prevButtons = element.querySelectorAll('[class~="carousel-control-prev"]'),
            imageItems = this.innerImage.querySelectorAll('[class~="carousel-item"]'),
            captionItems = this.innerCaption ? this.innerCaption.querySelectorAll('[class~="carousel-caption"]') : [],
            indicators = this.indicators || [],
            self = this,
            threshold = 50;

        this.total = imageItems.length;

        //clone images
        var firstImageItem = imageItems[0];
        var lastImageItem = imageItems[this.total - 1];
        this.innerImage.insertBefore(lastImageItem.cloneNode(true), firstImageItem);
        this.innerImage.appendChild(firstImageItem.cloneNode(true));


        if (captionItems.length > 0) {
            var firstCaptionItem = captionItems[0];
            var lastCaptionItem = captionItems[captionItems.length - 1];
            this.innerCaption.insertBefore(lastCaptionItem.cloneNode(true), firstCaptionItem);
            this.innerCaption.appendChild(firstCaptionItem.cloneNode(true));
        }

        _setTranslateX(-100, this.innerImage.style);
        if (this.innerCaption) {
            _setTranslateX(-100, this.innerCaption.style);
        }

        for (i = 0; i < nextButtons.length; ++i){
            nextButtons.item(i).addEventListener('click', _proxy(this.clickNext, this));
        }

        for (i = 0; i < prevButtons.length; ++i){
            prevButtons.item(i).addEventListener('click', _proxy(this.clickPrev,this))
        }

        for (i = 0; i < indicators.length; ++i) {
            (function(indicator){
                indicator.addEventListener('click', _proxy(self.slideTo, self, indicators.item(i).dataset.slideTo));
            }(indicators.item(i)));
        }

        var stillMoving = false;
        var start;

        if ('ontouchstart' in document.documentElement) {
            element.addEventListener('touchstart', onTouchStart, false);
        }

        function onTouchStart(e) {
            if (e.touches.length == 1) {
                start = e.touches[0].pageX;
                stillMoving = true;
                element.addEventListener('touchmove', onTouchMove, false);
            }
        }

        function onTouchMove(e) {
            if (stillMoving) {
                var x = e.touches[0].pageX;
                var difference = start - x;

                if (Math.abs(difference) >= threshold) {
                    cancelTouch();
                    if (difference > 0) {
                        self.clickNext();
                    }
                    else {
                        self.clickPrev();
                    }
                }
            }
        }

        function cancelTouch() {
            element.removeEventListener('touchmove', onTouchMove);
            start = null;
            stillMoving = false;
        }



    };

    Carousel.prototype.clickNext = function () {
        this.slideTo(this.index + 1, false);
    };

    Carousel.prototype.clickPrev = function () {
        //if(this.index === 0){
            this.slideTo(this.index - 1, true);
        //}
    };

    Carousel.prototype.slideTo = function (index, back) {
        if(this.isAnimation){
            return false;
        }

        this.isAnimation = true;

        this.oldIndex = this.index;



        //_removeClass(this.indicators.item(oldIndex), 'active');

//console.log(index)
       // _addClass(this.innerImage, 'animation');


        _setTranslateX(-100 - 100 * index, this.innerImage.style, 600 );

        if(this.innerCaption){
           // _addClass(this.innerCaption, 'animation');
            _setTranslateX(-100 - 100 * index, this.innerCaption.style, 600 );
        }


        setTimeout(_proxy(this.animationEnd, this), 600);
        //_addClass(this.indicators.item(index), 'active');
        this.index = index;

        return true;
    };

    Carousel.prototype.animationEnd = function () {
        // console.log('animationEnd');


        if(this.index < 0){
            _setTranslateX( - 100 * this.total, this.innerImage.style );

            if(this.innerCaption){
                _setTranslateX( - 100 * this.total, this.innerCaption.style );

            }

            this.index = this.total - 1;
        } else if(this.index >= this.total){
            _setTranslateX( - 100, this.innerImage.style );
            if(this.innerCaption){
                _setTranslateX( - 100, this.innerCaption.style );
            }
            this.index = 0;
        } else {
            _setTranslateX(-100 - 100 * this.index, this.innerImage.style );
            if(this.innerCaption){
                _setTranslateX(-100 - 100 * this.index, this.innerCaption.style);
            }

        }
        this.indicators.item(this.oldIndex) !== null && _removeClass(this.indicators.item(this.oldIndex), 'active');
        this.indicators.item(this.index) !== null && _addClass(this.indicators.item(this.index), 'active');

        this.isAnimation = false;
    };

    var old = window.carousel;

    window.carousel             = Plugin;
    window.carousel.Constructor = Carousel;


    // CAROUSEL NO CONFLICT
    // ====================

    window.carousel.noConflict = function () {
        window.carousel = old;
        return this
    };

    function Plugin(option) {
        // var data;
        // if (this.dataset.hasOwnProperty('carousel')) {
        //     data = this.dataset['carousel'];
        // } else {
            data = new Carousel(this);
            // this.dataset.carousel = data;
        // }
    }

    window.addEventListener('load', function () {
        var carousels = document.querySelectorAll('[data-ride="carousel-custom"]'), i, carousel, count = carousels.length;

        for (i = 0; i < count; ++i) {
            carousel = carousels.item(i);
            Plugin.call(carousel, carousel.dataset);
        }
    });

    // pjax:beforeReplace - kill plugin

    $(document).on("pjax:beforeReplace", function(ev) {

        // detach event listener
        // console.log("pjax:beforeReplace");

    });

    // after back or load from server
    $(document).on("pjax:end", function(ev, xhr, options) {


        // console.log("pjax:end");

        // запроса не было, значит это popstate и success не будет - выполняем здесь
        // if (xhr === null) {

        var carousels = document.querySelectorAll('[data-ride="carousel-custom"]'), i, carousel, count = carousels.length;

        for (i = 0; i < count; ++i) {
            carousel = carousels.item(i);
            Plugin.call(carousel, carousel.dataset);
        }
        
        

    
        // }
    });


})();